import React from 'react'

import { RotatingLines } from  'react-loader-spinner'
const Loading = () => {
  return (
   <div className='loading' style={{ height:'calc(100vh - 300px)' }}>
 <RotatingLines
  strokeColor="#ac8856"
  strokeWidth="4"
  strokeHeight="4"
  animationDuration="0.5"
  width="50"
  visible={true}
/>
   </div>
  )
}

export default Loading
